export default {"src":"/_next/static/media/productsList.533b4adb.svg","height":123,"width":35,"blurWidth":0,"blurHeight":0};